import React from 'react';
import ReactDOM from 'react-dom';
import Styles from './BaseModal.module.css'

const overlayInlineStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  zIndex: 9999,
  backgroundColor: 'rgba(0, 0, 0, 0.6)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const BaseModal = ({ showModal, overlayStyle, onClose, children, className, style }) => {
  if (!showModal) return null;

  const content = (
    <div style={overlayStyle ? undefined : overlayInlineStyle} className={overlayStyle ? overlayStyle : undefined}>
      {className ? (
        <div style={style} className={className}>
          {children}
        </div>
      ) : children}
    </div>
  );

  return ReactDOM.createPortal(content, document.body);
};

export default BaseModal;
